<template>
  <div class="pt-6 sm:pt-4">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div v-if="receipts" class="pt-4 max-w-4xl mx-auto text-center">
        <h2 class="text-3xl font-extrabold text-gray-900 sm:text-4xl">
          Email Receipts
        </h2>
        <p class="text-xl text-gray-500">
          This snap shot shows the last 30 days of activity
        </p>
      </div>
      <div v-else class="max-w-4xl mx-auto text-center">
        <h2 class="text-3xl font-extrabold text-gray-900 sm:text-4xl">
          Dashboard
        </h2>
        <p class="text-xl text-gray-500">CRM overview</p>
      </div>
    </div>

    <div v-if="receipts">
      <div class="mt-2 p-2 bg-white">
        <div class="max-w-4xl mx-auto">
          <dl class="rounded-lg bg-white shadow-lg sm:grid sm:grid-cols-3">
            <div
              class="flex flex-col border-t border-b border-gray-100 p-6 text-center sm:border-0 sm:border-l sm:border-r"
            >
              <dt
                class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500"
              >
                Total Delivered
              </dt>
              <dd class="order-1 text-5xl font-extrabold text-indigo-600">
                {{ totalDelivered }}
              </dd>
            </div>

            <div
              class="flex flex-col border-r border-gray-100 p-6 text-center sm:border-0 sm:border-l"
            >
              <dt
                class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500"
              >
                Open Emails
              </dt>
              <dd class="order-1 text-5xl font-extrabold text-indigo-600">
                {{ totalOpened }}
              </dd>
            </div>

            <div
              class="flex flex-col border-l border-gray-100 p-6 text-center sm:border-0 sm:border-r"
            >
              <dt
                class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500"
              >
                Total Faileds
              </dt>
              <dd class="order-1 text-5xl font-extrabold text-red-600">
                {{ totalFailed }}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="mt-6 p-4 bg-white">
        <div class="max-w-4xl mx-auto">
          <dl class="rounded-lg bg-white shadow-lg sm:grid sm:grid-cols-3">
            <div
              @click="checkEmailReceipt()"
              class="cursor-pointer flex flex-col border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r"
            >
              <dt
                class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500"
              >
                Email Reports
              </dt>
              <dd class="order-1 text-5xl font-extrabold text-indigo-600">
                {{ filterEmail.length }}
              </dd>
            </div>
            <div
              @click="checkSMSReceipt()"
              class="cursor-pointer flex flex-col border-t border-b border-gray-100 p-6 text-center sm:border-0 sm:border-l sm:border-r"
            >
              <dt
                class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500"
              >
                Sms Reports
              </dt>
              <dd class="order-1 text-5xl font-extrabold text-indigo-600">
                {{ filterSms.length }}
              </dd>
            </div>

            <div
              @click="pendingModal = true"
              class="cursor-pointer flex flex-col border-t border-gray-100 p-6 text-center sm:border-0 sm:border-l"
            >
              <dt
                class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500"
              >
                Pending Messages
              </dt>
              <dd class="order-1 text-5xl font-extrabold text-indigo-600">
                {{ stats.length }}
              </dd>
            </div>
          </dl>
        </div>
      </div>

      <!-- Modal -->
      <div class="fixed z-10  inset-0 overflow-y-auto" v-if="pendingModal">
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="md:text-left h-full w-full inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div
                class="-mx-4 mt-4 overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:-mx-6 md:mx-0 md:rounded-lg"
              >
                <table class="min-w-full divide-y divide-gray-300">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
                      >
                        Deliver Date(s)
                      </th>
                      <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                        <span class="sr-only">Edit</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200 bg-white">
                    <tr v-for="item in stats" :key="item.id">
                      <td
                        class="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6"
                      >
                        {{ item.message_name }}
                        <dl class="font-normal lg:hidden">
                          <dd class="mt-1 text-gray-500 sm:hidden">
                            <div
                              v-if="item.repeats"
                              class="mt-1 text-sm text-gray-900"
                            >
                              <span
                                v-for="deliver in item.repeats"
                                :key="deliver.id"
                              >
                                <span
                                  v-if="deliver.recurrent_day > actualDate"
                                  class="flex px-3 py-0.5 rounded-full text-sm font-light bg-orange-100 text-orange-800"
                                >
                                  {{ deliver.recurrent_day }}
                                </span>

                                <span
                                  v-else
                                  class="items-center px-3 py-0.5 rounded-full text-sm font-light bg-green-100 text-green-800"
                                >
                                  {{ deliver.recurrent_day }}
                                </span>
                              </span>
                            </div>
                            <div v-else>
                              <span
                                class="items-center px-3 py-0.5 rounded-full text-sm font-light bg-orange-100 text-orange-800"
                              >
                                {{ item.deliver_date }}
                              </span>
                            </div>
                          </dd>
                        </dl>
                      </td>
                      <td
                        class="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell"
                      >
                        <div
                          v-if="item.repeats"
                          class="mt-1 text-sm text-gray-900"
                        >
                          <span
                            v-for="deliver in item.repeats"
                            :key="deliver.id"
                          >
                            <span
                              v-if="deliver.recurrent_day > actualDate"
                              class="flex px-3 py-0.5 rounded-full text-sm font-light bg-orange-100 text-orange-800"
                            >
                              {{ deliver.recurrent_day }}
                            </span>

                            <span
                              v-else
                              class="items-center px-3 py-0.5 rounded-full text-sm font-light bg-green-100 text-green-800"
                            >
                              {{ deliver.recurrent_day }}
                            </span>
                          </span>
                        </div>
                        <div v-else>
                          <span
                            class="items-center px-3 py-0.5 rounded-full text-sm font-light bg-orange-100 text-orange-800"
                          >
                            {{ item.deliver_date }}
                          </span>
                        </div>
                      </td>
                      <td
                        class="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                      >
                        <a
                          @click="redirect(item)"
                          class="text-indigo-600 hover:text-indigo-900"
                        >
                          <svg
                            class="h-5 w-5 text-green-500"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" />
                            <path
                              d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
                            />
                            <path
                              d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"
                            />
                            <line x1="16" y1="5" x2="19" y2="8" />
                          </svg>
                        </a>
                      </td>
                    </tr>

                    <!-- More people... -->
                  </tbody>
                </table>
              </div>

              <div
                class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
              >
                <button
                  @click="pendingModal = false"
                  type="button"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: [
    "receipts",
    "messages",
    "stats",
    "totalFailed",
    "totalDelivered",
    "totalOpened"
  ],
  data() {
    return {
      pendingModal: false,
      actualDate: moment().format("YYYY-MM-DD")
    };
  },

  computed: {
    filterEmail() {
      return this.messages.filter(item => {
        if (item.mailgun.length > 0) {
          return item.message_type == 0;
        } else {
          return false;
        }
      });
    },

    filterSms() {
      return this.messages.filter(item => {
        if (item.mailgun.length > 0) {
          return item.message_type == 1;
        } else {
          return false;
        }
      });
    }
  },

  methods: {
    checkEmailReceipt() {
      this.$router.push({ name: "Receipt" });
    },

    checkSMSReceipt() {
      this.$router.push({ name: "SmsReceipt" });
    },

    redirect(message) {
      this.$router.push({ name: "CrmMessage", params: { id: message.id } });
    }
  }
};
</script>

<style></style>
